'use client';

import { usePipelineStore } from '@/lib/pipeline/store';
import { MirroredInput } from './MirroredInput';

/** Small "expose as API parameter" field for input nodes. */
export function ParamNameField({ id, value }: { id: string; value?: string | null }) {
  const update = usePipelineStore((s) => s.updateNodeData);
  return (
    <label className="text-[10px] text-[var(--text-muted)] block mt-1">
      API param
      <MirroredInput
        className="input nodrag w-full text-xs mt-0.5"
        placeholder="(none)"
        value={value ?? ''}
        onCommit={(v) => update(id, { param: v.trim() || null })}
      />
    </label>
  );
}
